import { makeObservable, observable, runInAction } from "mobx"
import React from "react";
import { JsxEmit } from "typescript";


class ImageStore {
  images: JSX.Element[] = [];
  previewImage: JSX.Element = <img />;
  previewImageLocked: boolean = false;
  constructor() {
    // this occurs error: [mobx] Dynamic observable objects cannot be frozen]
    //makeAutoObservable(this);
    makeObservable<ImageStore>(this, {
      images: observable.shallow,
      previewImage: observable,
      previewImageLocked: observable,
    })
  }
  setImages(newImages: JSX.Element[]) {
    this.images = newImages;
  }

  addImage(newImage: JSX.Element) {
    this.images.push(newImage);
  }

  setPreviewImage(newImage: JSX.Element) {
    if (this.previewImageLocked)  return;
    runInAction(() => {
      this.previewImage = newImage;
    });
  }

  unsetPreviewImage() {
    if (this.previewImageLocked)  return;
    runInAction(() => {
      this.previewImage = <img></img>;
    });
  }

  lockPreviewImage() {
    runInAction(() => {
      this.previewImageLocked = true;
    });
  }
  unlockPreviewImage() {
    runInAction(() => {
      this.previewImageLocked = false;
    });
  }
}

export default ImageStore;